var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.82826V13.1717C3 13.5205 3.18172 13.8441 3.47954 14.0256L9.47954 17.6828C9.79917 17.8776 10.2008 17.8776 10.5205 17.6828L16.5205 14.0256C16.8183 13.8441 17 13.5205 17 13.1717V6.82826C17 6.47948 16.8183 6.1559 16.5205 5.97438L10.5205 2.31723C10.2008 2.12241 9.79917 2.12241 9.47954 2.31723L3.47954 5.97438C3.18172 6.1559 3 6.47948 3 6.82826Z",
    stroke: "#2E2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7L10 10.6667M10 10.6667L16 7M10 10.6667V18",
    stroke: "#2E2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3D);
export default __webpack_public_path__ + "static/media/image3D.ff15d976fafa62f64b890326286c0154.svg";
export { ForwardRef as ReactComponent };